import { render, staticRenderFns } from "./dianquan.vue?vue&type=template&id=1443cccc&"
import script from "./dianquan.vue?vue&type=script&lang=ts&"
export * from "./dianquan.vue?vue&type=script&lang=ts&"
import style0 from "./dianquan.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports